const { makeStyles } = require("@material-ui/core");

const useStyles = makeStyles((theme) => ({
    buttonContainer: {
        width: '100%',
        paddingBottom: 70,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-end',
        flexGrow: 1
    },
    stepperContainer: {
        '& .MuiMobileStepper-dot': {
            width: 15,
            height: 15
        }
    },
}));

export default useStyles;